import { AdminConvertLeadResult } from "tech-health-assessment-sdk/dist";
import { api } from "../../../../../services/core-api-service";

class ConvertToClientDialogService {
    public async convertLeadToClient(accountId: string): Promise<AdminConvertLeadResult> {
        return api.admin.convertLeadToClient(accountId, {})
    }
}

export const service = new ConvertToClientDialogService()